import moment from 'moment';
import React, { Fragment, useState, useEffect } from 'react';
import { Col, Container, Row, Card, CardBody, Progress } from 'reactstrap';


const TranscriptionProfile = ({ user }) => {
    const [totalTransciption, setTotalTransciption] = useState(0);
    const [missionForTranscription, setMissionForTranscription] = useState(0);
    const today = moment(new Date(), 'YYYY/MM/DD');

    useEffect(() => {
        var month = today.format('M');
        var day = today.format('D');
        var year = today.format('YYYY');
        var daysInMonth = moment(year + '-' + month, "YYYY-MM").daysInMonth();

        console.log("FECHAHOY", today, month, day, year, daysInMonth);

        const getInfoTrancriptions = async () => {
            let dataSend = {
                fecha_inicio: moment(year + '-' + month + '-01' + " 00:00:00").format('YYYY-MM-DD HH:mm:ss'),
                fecha_final: moment(year + '-' + month + '-' + daysInMonth + " 23:59:59").format('YYYY-MM-DD HH:mm:ss'),
                id_usuario: user?.id_usuario,
                es_doctor: false
            }

            await fetch(process.env.REACT_APP_PUBLIC_URL + 'usuario/revisar-transcripciones', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'authorization': 'Bearer ' + sessionStorage.getItem('token'),
                },
                body: JSON.stringify(dataSend)
            })
                .then(response => {
                    return response.json();
                })
                .then(data => {
                    console.log("TRANS", data.data);
                    if (data !== null && data !== undefined) {
                        if(data.data.hasOwnProperty('pendientes')) setMissionForTranscription((prev) => prev + data.data.pendientes);
                        if(data.data.hasOwnProperty('aprobadas')) setTotalTransciption((prev) => prev + data.data.aprobadas);
                    }else{
                        setMissionForTranscription((prev) => prev + 0);
                        setTotalTransciption((prev) => prev + 0);  
                    }
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
        };
        getInfoTrancriptions();
    }, [])


    return (
        <Fragment>
            <Col md={12} lg={5} xl={3} xs={12}>
                <Card>
                    <CardBody style={{ padding: 0 }}>
                        <div className='dashboard__visitors-technologist'>
                            <div className='title'><h5><b>Transcripciones</b></h5></div>
                            <div className="mobile-app-widget">
                                <div className="mobile-app-widget__top-line mobile-app-widget__top-line--blue">
                                    <p className="mobile-app-widget__total-stat">{missionForTranscription} </p> <span>Pendientes</span>
                                </div>
                                <div className="progress-wrap progress-wrap--small progress-wrap--blue-gradient progress-wrap--label-top">
                                    <Progress value={missionForTranscription}><p className="progress__label"></p></Progress>
                                </div>
                                <hr />
                            </div>
                            <div className="mobile-app-widget">
                                <div className="mobile-app-widget__top-line mobile-app-widget__top-line--blue">
                                    <p className="mobile-app-widget__total-stat">{totalTransciption}</p> <span>Realizadas</span>
                                </div>
                                <div className="progress-wrap progress-wrap--small progress-wrap--blue-gradient progress-wrap--label-top">
                                    <Progress value={totalTransciption}><p className="progress__label"></p></Progress>
                                </div>
                            </div>
                        </div>
                    </CardBody>
                </Card>
            </Col>
        </Fragment>
    )
}

export default TranscriptionProfile